import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonios" title="Lo que dicen quienes ya lo tienen" width="narrow" data-id="element-238" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-narrow divide-y divide-blue-200/70" data-id="element-239" data-mp="3azjefymrcmcq">
        {testimonials.map(item => <li key={`${item.author}-${item.city}`} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-240" data-mp="370kaohcrivmv">
            <div className="flex items-start gap-3" data-id="element-241" data-mp="2x1urml94r551">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 font-display text-xs font-bold text-white" data-id="element-242" data-mp="2x2mlnrn2wut7">
                {item.initials}
              </span>
              <span data-id="element-243" data-mp="qac393b1qh1z">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-244" data-mp="q9u0roxsj6lm">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-245" data-mp="h4n2k87sbt9c" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-246" data-mp="c6ll1rq0c1zz">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-247" data-mp="zwxzllfrcwzj">{item.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-248" data-mp="14u7p1135d8nd">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-249" data-mp="q5lcf74wmuzu" />
                  {item.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-ink md:text-xl" data-id="element-250" data-mp="1ivk3t96kn47o">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}